import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
declare const marked: any;

@Pipe({
  name: 'decodeHtml',
  pure: false,
})
export class DecodeHtmlPipe implements PipeTransform {
  transform(value: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = value;
    return txt.value;
  }
}
